var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "message-illustration" }, [
    _vm.illustrationId === "japanese-scripts"
      ? _c(
          "svg",
          {
            attrs: {
              width: "128",
              height: "40",
              viewBox: "0 0 128 40",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("rect", {
              attrs: { width: "128", height: "40", rx: "8", fill: "#F7F8FA" },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M35.5 11C35.5 14.3137 32.8137 17 29.5 17C26.1863 17 23.5 14.3137 23.5 11C23.5 7.68629 26.1863 5 29.5 5C32.8137 5 35.5 7.68629 35.5 11Z",
                fill: "#63E1E7",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M30.8281 11.4848C33.5704 12.1817 40.7005 12.8787 47.282 10.0908",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M38.3695 8C36.3128 12.8788 35.6272 19.5697 38.3695 29.6061",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M42.4831 31.0003C44.0828 31.0003 47.6935 30.0246 49.3389 26.1215C51.1028 21.9374 49.337 18.2659 44.0415 17.3052M44.0415 17.3052C43.1623 17.1457 42.1858 17.0609 41.1119 17.0609C33.5706 17.0609 29.1313 23.4025 30.1427 27.5155C31.2885 32.1753 40.2525 28.5695 44.0415 17.3052ZM44.0415 17.3052C44.2195 16.776 44.3861 16.2299 44.5399 15.667",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M84.5 11C84.5 14.3137 81.8137 17 78.5 17C75.1863 17 72.5 14.3137 72.5 11C72.5 7.68629 75.1863 5 78.5 5C81.8137 5 84.5 7.68629 84.5 11Z",
                fill: "#E2B4FF",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M78 11H95.5981C96.5181 11 97.2163 11.8135 96.9382 12.6744C96.2411 14.8324 94.5664 18.124 90.6556 19.7692M86.9334 16.8462C86.9334 24.1538 84.7 27.8077 79.4889 30",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
          ]
        )
      : _vm.illustrationId === "hiragana-katakana"
      ? _c(
          "svg",
          {
            attrs: {
              width: "120",
              height: "40",
              viewBox: "0 0 120 40",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M34 11C34 14.866 30.866 18 27 18C23.134 18 20 14.866 20 11C20 7.13401 23.134 4 27 4C30.866 4 34 7.13401 34 11Z",
                fill: "#63E1E7",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M5 11.894C7.4 11.894 12.8 11.1599 15.2 8.2235C10.6 14.1371 3.2 29.023 13.4 33.3053C21.978 36.9066 31.758 26.2304 26.791 7.69123M26.791 7.69123C26.7296 7.46202 26.6659 7.23161 26.6 7C26.653 7.21595 26.7168 7.44726 26.791 7.69123ZM26.791 7.69123C27.8387 11.1335 30.9659 17.0975 35 18.0115",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M114 11C114 14.866 110.866 18 107 18C103.134 18 100 14.866 100 11C100 7.13401 103.134 4 107 4C110.866 4 114 7.13401 114 11Z",
                fill: "#E2B4FF",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M86 13L108 13V29.1778C108 31.6667 106.743 32.9111 104.857 33.5334C102.971 34.1556 100.457 34.1555 99.2 33.5333",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M94 6V18.8696C94 27.0652 92.6667 32.1087 88 34",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
          ]
        )
      : _vm.illustrationId === "hiragana"
      ? _c(
          "svg",
          {
            attrs: {
              width: "248",
              height: "40",
              viewBox: "0 0 248 40",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("rect", {
              attrs: { width: "248", height: "40", rx: "8", fill: "#F7F8FA" },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M19.7453 13.0303C22.2134 13.6364 28.6304 14.2424 34.5538 11.8182M26.5325 10C24.6814 14.2424 24.0644 20.0606 26.5325 28.7879M30.2348 30C31.6745 30 34.9242 29.1515 36.405 25.7576C37.9925 22.1192 36.4033 18.9266 31.6373 18.0912M31.6373 18.0912C30.846 17.9525 29.9672 17.8788 29.0008 17.8788C22.2135 17.8788 18.2182 23.3932 19.1284 26.9697C20.1597 31.0217 28.2272 27.8862 31.6373 18.0912ZM31.6373 18.0912C31.7975 17.631 31.9474 17.1562 32.0859 16.6667",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M67.1593 12C66.7899 16.2037 66.8268 25.269 69.93 27.9008C73.809 31.1907 75.2867 26.2559 76.0255 24.0627M82.121 13.6449C83.2293 15.1071 85.5567 19.457 86 25.1593",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M119.5 11C121 11.3333 125 12 129 12M117 18C120.167 16.6667 127.1 14.9 129.5 18.5C132.5 23 128 28 121 29",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M168.243 10.0299C167.707 9.89591 167.164 10.2217 167.03 10.7575C166.896 11.2933 167.222 11.8362 167.757 11.9701L168.243 10.0299ZM175.917 12.9965C176.467 13.0424 176.951 12.6334 176.997 12.083C177.042 11.5327 176.633 11.0493 176.083 11.0035L175.917 12.9965ZM165 16.5C164.448 16.5 164 16.9477 164 17.5C164 18.0523 164.448 18.5 165 18.5V16.5ZM176 16.5L176.721 17.1925L175.859 15.5101L176 16.5ZM168.32 24.5L169.041 25.1925L168.32 24.5ZM163.279 28.3075C162.896 28.7059 162.909 29.3389 163.307 29.7214C163.706 30.1039 164.339 30.0909 164.721 29.6925L163.279 28.3075ZM172.5 23.5L171.986 24.3575V24.3575L172.5 23.5ZM176 29L175.684 29.9487L176 29ZM180.816 29.9487C181.34 29.774 181.623 29.2077 181.449 28.6838C181.274 28.1598 180.708 27.8767 180.184 28.0513L180.816 29.9487ZM167.757 11.9701C168.507 12.1576 171.108 12.5958 175.917 12.9965L176.083 11.0035C171.292 10.6042 168.826 10.1757 168.243 10.0299L167.757 11.9701ZM165 18.5C166.391 18.5 170.507 18.2949 176.141 17.4899L175.859 15.5101C170.293 16.3051 166.275 16.5 165 16.5V18.5ZM175.279 15.8075L167.854 23.5418L169.296 24.9269L176.721 17.1925L175.279 15.8075ZM167.854 23.5418L167.599 23.8075L169.041 25.1925L169.296 24.9269L167.854 23.5418ZM167.599 23.8075L163.279 28.3075L164.721 29.6925L169.041 25.1925L167.599 23.8075ZM169.074 25.1572C169.127 25.0957 169.191 25.0284 169.265 24.9582L167.885 23.5105C167.769 23.6213 167.662 23.733 167.566 23.8428L169.074 25.1572ZM169.265 24.9582C170.002 24.2559 171.053 23.7978 171.986 24.3575L173.014 22.6425C170.87 21.3557 168.806 22.6329 167.885 23.5105L169.265 24.9582ZM171.986 24.3575C172.786 24.8381 172.876 25.4661 173.078 26.6113C173.171 27.1394 173.303 27.8284 173.687 28.453C174.098 29.1225 174.739 29.6336 175.684 29.9487L176.316 28.0513C175.761 27.8664 175.527 27.6275 175.391 27.4064C175.228 27.1404 175.142 26.7981 175.047 26.2637C174.874 25.2839 174.714 23.6619 173.014 22.6425L171.986 24.3575ZM175.684 29.9487C178.308 30.8233 180.259 30.1344 180.816 29.9487L180.184 28.0513C179.741 28.1989 178.309 28.7155 176.316 28.0513L175.684 29.9487Z",
                fill: "#2C3143",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M211.047 15C212.881 15.1667 217.447 15.2 221.047 14M224.547 13.5C225.214 13.6667 227.047 14.5 229.047 16.5M216.047 11V20.7498M216.047 20.7498V26.5C216.047 27.5 215.047 29.5 212.547 28.5C210.047 27.5 210.047 25 211.547 23.5C212.31 22.7369 213.904 21.5717 216.047 20.7498ZM216.047 20.7498C218.118 19.9561 220.701 19.4825 223.547 20C229.047 21 228.047 28.5 220.547 29",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
          ]
        )
      : _vm.illustrationId === "hiragana-learning"
      ? _c(
          "svg",
          {
            attrs: {
              width: "40",
              height: "40",
              viewBox: "0 0 40 40",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M34 11C34 14.866 30.866 18 27 18C23.134 18 20 14.866 20 11C20 7.13401 23.134 4 27 4C30.866 4 34 7.13401 34 11Z",
                fill: "#63E1E7",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M5 11.894C7.4 11.894 12.8 11.1599 15.2 8.2235C10.6 14.1371 3.2 29.023 13.4 33.3053C21.978 36.9066 31.758 26.2304 26.791 7.69123M26.791 7.69123C26.7296 7.46202 26.6659 7.23161 26.6 7C26.653 7.21595 26.7168 7.44726 26.791 7.69123ZM26.791 7.69123C27.8387 11.1335 30.9659 17.0975 35 18.0115",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
          ]
        )
      : _vm.illustrationId === "form-spelling"
      ? _c(
          "svg",
          {
            attrs: {
              width: "40",
              height: "40",
              viewBox: "0 0 40 40",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M20 34L24 28L19 22H11V10H7C5.89543 10 5 10.8954 5 12V26C5 27.1046 5.89543 28 7 28H16L20 34Z",
                fill: "#8EA3EE",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M31 6H33C34.1046 6 35 6.89543 35 8V20C35 21.1046 34.1046 22 33 22H27L23 28L19 22H13C11.8954 22 11 21.1046 11 20V8C11 6.89543 11.8954 6 13 6H23",
                stroke: "#2C3143",
                "stroke-width": "3",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            }),
          ]
        )
      : _vm.illustrationId === "korean-scripts"
      ? _c(
          "svg",
          {
            attrs: {
              width: "128",
              height: "40",
              viewBox: "0 0 128 40",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("rect", {
              attrs: { width: "128", height: "40", rx: "8", fill: "#F7F8FA" },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M88 23.6667C88 31.0305 81.9324 37 74.4476 37C68.9583 37 64.2312 33.7891 62.1009 29.1723C61.6669 28.2313 62.7361 27.5841 63.3529 28.2313C64.4956 29.4304 65.9747 30.3333 67.6714 30.3333C71.4138 30.3333 74.4476 27.3486 74.4476 23.6667C74.4476 19.9848 77.4814 17 81.2238 17C84.9662 17 88 19.9848 88 23.6667Z",
                fill: "#8EA3EE",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M66 8H78C78.1667 9.33333 78.2 12.6 77 15",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M66 18C65.4477 18 65 18.4477 65 19C65 19.5523 65.4477 20 66 20V18ZM79 19H80V18H79V19ZM79 23V24C79.5523 24 80 23.5523 80 23H79ZM66 23V22C65.4477 22 65 22.4477 65 23H66ZM66 27H65V28H66V27ZM79 28C79.5523 28 80 27.5523 80 27C80 26.4477 79.5523 26 79 26V28ZM66 20H79V18H66V20ZM78 19V23H80V19H78ZM79 22H66V24H79V22ZM65 23V27H67V23H65ZM66 28H79V26H66V28Z",
                fill: "#2C3143",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M81 15H63",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M40 9H50",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M45 9L45 6",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M44 22V27H56",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M55 7V21",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M59 14H55",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("ellipse", {
              attrs: {
                cx: "45.5",
                cy: "16",
                rx: "4.5",
                ry: "3",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
          ]
        )
      : _vm.illustrationId === "korean-hangeul"
      ? _c(
          "svg",
          {
            attrs: {
              width: "40",
              height: "40",
              viewBox: "0 0 40 40",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M31 25.6667C31 31.9259 25.8659 37 19.5326 37C14.8878 37 10.888 34.2708 9.08539 30.3464C8.71811 29.5466 9.62282 28.9965 10.1448 29.5466C11.1117 30.5658 12.3632 31.3333 13.7989 31.3333C16.9655 31.3333 19.5326 28.7963 19.5326 25.6667C19.5326 22.5371 22.0997 20 25.2663 20C28.4329 20 31 22.5371 31 25.6667Z",
                fill: "#8EA3EE",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M9 10L21 10",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M15 10L15 6",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M13 26V32H28",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M27 7V25",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M32 16H27",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("ellipse", {
              attrs: {
                cx: "15",
                cy: "17.5",
                rx: "6",
                ry: "3.5",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
          ]
        )
      : _vm.illustrationId === "korean-hangeul-scripts"
      ? _c(
          "svg",
          {
            attrs: {
              width: "248",
              height: "40",
              viewBox: "0 0 248 40",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("rect", {
              attrs: { width: "248", height: "40", rx: "8", fill: "#F7F8FA" },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M189 10V30",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M58 11V29",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M58 19H63",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M89 11V29",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M93 10V30",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M85 19H89",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M113 24H131",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M122 24V15",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M148 17H166",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M157 26V17",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
          ]
        )
      : _vm.illustrationId === "hangeul-learning"
      ? _c(
          "svg",
          {
            attrs: {
              width: "40",
              height: "45",
              viewBox: "0 0 40 45",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("g", { attrs: { filter: "url(#filter0_d_5748_265330)" } }, [
              _c("path", {
                attrs: {
                  d: "M30.7354 25.6647C30.7354 31.9218 25.663 36.9942 19.4059 36.9942C14.817 36.9942 10.8653 34.2659 9.08436 30.3429C8.7215 29.5434 9.61533 28.9934 10.131 29.5434C11.0863 30.5622 12.3227 31.3295 13.7412 31.3295C16.8697 31.3295 19.4059 28.7933 19.4059 25.6647C19.4059 22.5362 21.9421 20 25.0707 20C28.1992 20 30.7354 22.5362 30.7354 25.6647Z",
                  fill: "#8EA3EE",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M9 10L21 10",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M15 10L15 6",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M13 26V32H28",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M27 7V25",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M32 16H27",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "15",
                  cy: "17.5",
                  rx: "6",
                  ry: "3.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
            ]),
            _vm._v(" "),
            _c("defs", [
              _c(
                "filter",
                {
                  attrs: {
                    id: "filter0_d_5748_265330",
                    x: "-4",
                    y: "0",
                    width: "48",
                    height: "48",
                    filterUnits: "userSpaceOnUse",
                    "color-interpolation-filters": "sRGB",
                  },
                },
                [
                  _c("feFlood", {
                    attrs: {
                      "flood-opacity": "0",
                      result: "BackgroundImageFix",
                    },
                  }),
                  _vm._v(" "),
                  _c("feColorMatrix", {
                    attrs: {
                      in: "SourceAlpha",
                      type: "matrix",
                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                      result: "hardAlpha",
                    },
                  }),
                  _vm._v(" "),
                  _c("feOffset", { attrs: { dy: "4" } }),
                  _vm._v(" "),
                  _c("feGaussianBlur", { attrs: { stdDeviation: "2" } }),
                  _vm._v(" "),
                  _c("feComposite", {
                    attrs: { in2: "hardAlpha", operator: "out" },
                  }),
                  _vm._v(" "),
                  _c("feColorMatrix", {
                    attrs: {
                      type: "matrix",
                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
                    },
                  }),
                  _vm._v(" "),
                  _c("feBlend", {
                    attrs: {
                      mode: "normal",
                      in2: "BackgroundImageFix",
                      result: "effect1_dropShadow_5748_265330",
                    },
                  }),
                  _vm._v(" "),
                  _c("feBlend", {
                    attrs: {
                      mode: "normal",
                      in: "SourceGraphic",
                      in2: "effect1_dropShadow_5748_265330",
                      result: "shape",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        )
      : _vm.illustrationId === "voice-input"
      ? _c(
          "div",
          { staticClass: "illustration-wrapper" },
          [
            _c("lottie-animation", {
              attrs: { animationData: this.voiceInputAnim, loop: true },
            }),
          ],
          1
        )
      : _vm.illustrationId === "russian-cyrillic"
      ? _c(
          "svg",
          {
            attrs: {
              width: "128",
              height: "40",
              viewBox: "0 0 128 40",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("rect", {
              attrs: { width: "128", height: "40", rx: "8", fill: "#F7F8FA" },
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "54",
                y: "24",
                width: "48",
                height: "10",
                rx: "4",
                fill: "#E2B4FF",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M22 14L16 25C15 26.5 13.5 26.5 12 26M12 14L17 23.1667",
                stroke: "#2C3143",
                "stroke-width": "2",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M34 26H33V27H34V26ZM35 14V13H33V14H35ZM35 26V20H33V26H35ZM35 20V14H33V20H35ZM34 21H40.1875V19H34V21ZM40.1875 25H34V27H40.1875V25ZM42 23C42 24.1663 41.1287 25 40.1875 25V27C42.3529 27 44 25.1474 44 23H42ZM40.1875 21C41.1287 21 42 21.8337 42 23H44C44 20.8526 42.3529 19 40.1875 19V21ZM48 27V13H46V27H48Z",
                fill: "#2C3143",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M59 25.1962C59.9121 25.7228 60.9468 26 62 26C63.0532 26 64.0879 25.7228 65 25.1962C65.9121 24.6695 66.6695 23.9121 67.1962 23C67.7228 22.0879 68 21.0532 68 20M68 20C68 18.9468 67.7228 17.9121 67.1962 17C66.6695 16.0879 65.9121 15.3305 65 14.8038C64.0879 14.2772 63.0532 14 62 14C60.9468 14 59.9121 14.2772 59 14.8038M68 20H60",
                stroke: "#2C3143",
                "stroke-width": "2",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M85 20C85 23.3137 87.4624 26 90.5 26C93.5376 26 96 23.3137 96 20C96 16.6863 93.5376 14 90.5 14C87.4624 14 85 16.6863 85 20ZM85 20H80M80 20V13M80 20V27",
                stroke: "#2C3143",
                "stroke-width": "2",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M116 27V21M116 21V14H112.5C110.567 14 109 15.567 109 17.5C109 19.433 110.567 21 112.5 21H116ZM112 21L108 27",
                stroke: "#2C3143",
                "stroke-width": "2",
              },
            }),
          ]
        )
      : _vm.illustrationId === "russian-cyrillic-deck"
      ? _c(
          "svg",
          {
            attrs: {
              width: "40",
              height: "40",
              viewBox: "0 0 40 40",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("rect", {
              attrs: {
                x: "10",
                y: "15",
                width: "18",
                height: "18",
                rx: "4",
                fill: "#E2B4FF",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M21 29C21 32.3137 23.4624 35 26.5 35C29.5376 35 32 32.3137 32 29C32 25.6863 29.5376 23 26.5 23C23.4624 23 21 25.6863 21 29ZM21 29H16M16 29V22M16 29V36",
                stroke: "#2C3143",
                "stroke-width": "2",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M16 18V12M16 12H12.5C10.567 12 9 10.433 9 8.5C9 6.567 10.567 5 12.5 5H16V8M16 12V11M12 12L8 18",
                stroke: "#2C3143",
                "stroke-width": "2",
              },
            }),
          ]
        )
      : _vm.illustrationId === "russian-cyrillic-script"
      ? _c(
          "svg",
          {
            attrs: {
              width: "248",
              height: "40",
              viewBox: "0 0 248 40",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("rect", {
              attrs: { width: "248", height: "40", rx: "8", fill: "#F7F8FA" },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M116 20C116 22.7614 114.209 25 112 25C109.791 25 108 22.7614 108 20C108 17.2386 109.791 15 112 15C114.209 15 116 17.2386 116 20Z",
                stroke: "#2C3143",
                "stroke-width": "2",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M19 25V18.659C19 16.8977 17.8 13.7979 13 15.4887M19 20H14.5C13.1193 20 12 21.1193 12 22.5C12 23.8807 13.1193 25 14.5 25H16L19 22V20Z",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "square",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M35 19.6671V19C35 16.7909 36.7909 15 39 15C41.2091 15 43 16.7909 43 19V19.6671H35ZM35 19.6671C35 24.3343 38.2 26.0844 42.4667 24.3343",
                stroke: "#2C3143",
                "stroke-width": "2",
                "stroke-linecap": "square",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M63 12C63 12.5523 62.5523 13 62 13C61.4477 13 61 12.5523 61 12C61 11.4477 61.4477 11 62 11C62.5523 11 63 11.4477 63 12ZM59 19C59 16.2386 61.2386 14 64 14C66.7614 14 69 16.2386 69 19V19.6671V20.6671H68H61.0594C61.249 22.174 61.8737 23.084 62.6489 23.5503C63.6107 24.129 65.117 24.2172 67.0872 23.4091L68.0123 23.0296L68.7714 24.8799L67.8462 25.2595C65.5497 26.2015 63.3227 26.2898 61.6178 25.2641C59.8847 24.2214 59 22.2178 59 19.6671V19ZM66.9817 18.6671C66.8161 17.1669 65.5443 16 64 16C62.4557 16 61.1839 17.1669 61.0183 18.6671H66.9817ZM66 13C66.5523 13 67 12.5523 67 12C67 11.4477 66.5523 11 66 11C65.4477 11 65 11.4477 65 12C65 12.5523 65.4477 13 66 13Z",
                fill: "#2C3143",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M84 25H83V26H84V25ZM91 15V14H90.4338L90.1425 14.4855L91 15ZM91 25V26H93V25H91ZM92 15H93V14H92V15ZM85 25V26H85.5662L85.8575 25.5145L85 25ZM83 14V25H85V14H83ZM91 16H92V14H91V16ZM91 15V25H93V15H91ZM84 26H85V24H84V26ZM85.8575 25.5145L91.8575 15.5145L90.1425 14.4855L84.1425 24.4855L85.8575 25.5145Z",
                fill: "#2C3143",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M141 14C138.901 18.7124 137.693 21.4262 135.656 26C135 27.4734 133.853 28.7535 132 28M133 14L136.992 23",
                stroke: "#2C3143",
                "stroke-width": "2",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M154 25H153V26H154V25ZM155 15V14H153V15H155ZM155 25V20H153V25H155ZM155 20V15H153V20H155ZM154 21H159.5V19H154V21ZM159.5 24H154V26H159.5V24ZM161 22.5C161 23.3284 160.328 24 159.5 24V26C161.433 26 163 24.433 163 22.5H161ZM159.5 21C160.328 21 161 21.6716 161 22.5H163C163 20.567 161.433 19 159.5 19V21ZM167 26V14H165V26H167Z",
                fill: "#2C3143",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M181 24.3301C181.76 24.769 182.622 25 183.5 25C184.378 25 185.24 24.769 186 24.3301C186.76 23.8913 187.391 23.2601 187.83 22.5C188.269 21.7399 188.5 20.8777 188.5 20M188.5 20C188.5 19.1223 188.269 18.2601 187.83 17.5C187.391 16.7399 186.76 16.1087 186 15.6699C185.24 15.231 184.378 15 183.5 15C182.622 15 181.76 15.231 181 15.6699M188.5 20H181.5",
                stroke: "#2C3143",
                "stroke-width": "2",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M207.438 20C207.438 22.3669 209.13 24.2857 211.219 24.2857C213.307 24.2857 215 22.3669 215 20C215 17.6331 213.307 15.7143 211.219 15.7143C209.13 15.7143 207.438 17.6331 207.438 20ZM207.438 20H204M204 20V15M204 20V25",
                stroke: "#2C3143",
                "stroke-width": "2",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M236 25V20.8462M236 20.8462V16L233 16C231.792 16 230.812 17.0848 230.812 18.4231C230.812 19.7613 231.792 20.8462 233 20.8462H236ZM232.5 20.7826L230 25",
                stroke: "#2C3143",
                "stroke-width": "2",
              },
            }),
          ]
        )
      : _vm.illustrationId === "russian-cyrillic-script-small"
      ? _c(
          "svg",
          {
            attrs: {
              width: "40",
              height: "44",
              viewBox: "0 0 40 44",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("g", { attrs: { filter: "url(#filter0_d_6353_278705)" } }, [
              _c("rect", {
                attrs: {
                  x: "10",
                  y: "15",
                  width: "18",
                  height: "18",
                  rx: "4",
                  fill: "#E2B4FF",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M21 29C21 32.3137 23.4624 35 26.5 35C29.5376 35 32 32.3137 32 29C32 25.6863 29.5376 23 26.5 23C23.4624 23 21 25.6863 21 29ZM21 29H16M16 29V22M16 29V36",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M16 18V12M16 12H12.5C10.567 12 9 10.433 9 8.5C9 6.567 10.567 5 12.5 5H16V8M16 12V11M12 12L8 18",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
            ]),
            _vm._v(" "),
            _c("defs", [
              _c(
                "filter",
                {
                  attrs: {
                    id: "filter0_d_6353_278705",
                    x: "-4",
                    y: "0",
                    width: "48",
                    height: "48",
                    filterUnits: "userSpaceOnUse",
                    "color-interpolation-filters": "sRGB",
                  },
                },
                [
                  _c("feFlood", {
                    attrs: {
                      "flood-opacity": "0",
                      result: "BackgroundImageFix",
                    },
                  }),
                  _vm._v(" "),
                  _c("feColorMatrix", {
                    attrs: {
                      in: "SourceAlpha",
                      type: "matrix",
                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                      result: "hardAlpha",
                    },
                  }),
                  _vm._v(" "),
                  _c("feOffset", { attrs: { dy: "4" } }),
                  _vm._v(" "),
                  _c("feGaussianBlur", { attrs: { stdDeviation: "2" } }),
                  _vm._v(" "),
                  _c("feComposite", {
                    attrs: { in2: "hardAlpha", operator: "out" },
                  }),
                  _vm._v(" "),
                  _c("feColorMatrix", {
                    attrs: {
                      type: "matrix",
                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
                    },
                  }),
                  _vm._v(" "),
                  _c("feBlend", {
                    attrs: {
                      mode: "normal",
                      in2: "BackgroundImageFix",
                      result: "effect1_dropShadow_6353_278705",
                    },
                  }),
                  _vm._v(" "),
                  _c("feBlend", {
                    attrs: {
                      mode: "normal",
                      in: "SourceGraphic",
                      in2: "effect1_dropShadow_6353_278705",
                      result: "shape",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }